import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

import { requireGuest } from "@/lib/route-guards"
import { SignInPage } from "@/pages/sign-in"

/**
 * `redirect_url` = same-origin path to land on after auth (non-invite flows); sanitized in the
 * page via `safeRedirectPath`. `invite` = explicit invite token — never Clerk's own
 * `redirect_url`, which it puts in the URL hash on its sign-in/sign-up cross-links where the SPA
 * can't read it as a search param (see docs/auth.md).
 */
const authRedirectSearchSchema = z.object({
  redirect_url: z.string().optional(),
  invite: z.string().optional(),
})

export const Route = createFileRoute("/sign-in/$")({
  validateSearch: authRedirectSearchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.auth.isSignedIn && search.invite != null) {
      // Already signed in with an invite in hand: let `/invite/$token` decide accept vs sign-out.
      throw redirect({ to: "/invite/$token", params: { token: search.invite } })
    }
    requireGuest(context)
  },
  component: SignInPage,
})
